export class Bookmarks {
  activities : string[] = [];
  restaurants: string[] = [];
  accommodations: string[] = [];
  events: string[] = [];
  stays: string[] = [];
  services: string[] = [];
  others: string[] = [];
  all: string[] = [];

  toJson(){
    return JSON.stringify(this);
  }

  static fromJson(json:string){
    return Object.assign(new Bookmarks(), JSON.parse(json));
  }
}
